import OptionsList from "@components/systemAdmin/OptionsList";
import React from "react";
import { Tab } from "semantic-ui-react";

const Options = (props) => {
  return (
    <div className="gs-flex-container-vertical h-100">
      <div className="table-overflow flex-stretch-vertical p-1">
        <OptionsList
          labelWidth="9"
          options={props.options}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
};

const ProfileTabs = (props) => {
  const panes = [
    {
      menuItem: "CMS",
      pane: (
        <Tab.Pane>
          <Options
            options={props.cms}
            onChange={(option, value) => props.onChange("cms", option, value)}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Site Controller",
      pane: (
        <Tab.Pane>
          <Options
            options={props.siteController}
            onChange={(option, value) =>
              props.onChange("siteController", option, value)
            }
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Mobile",
      pane: (
        <Tab.Pane>
          <Options
            options={props.cmsMobile}
            onChange={(option, value) =>
              props.onChange("cmsMobile", option, value)
            }
          />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <Tab
      renderActiveOnly={false}
      panes={panes}
      className="gs-flex-container-vertical flex-stretch h-100"
    />
  );
};

export default ProfileTabs;
